module.exports = __webpack_public_path__ + "static/media/D5.efacc476.png";